(() => {
  const SEL = window.ProductVariantSelectors;
  const dropdownRefreshers = [];

  const selectedOptionValues = (selects) => {
    const selected = {};
    selects.forEach((select) => (selected[select.name] = select.value));
    return selected;
  };

  const updateSelectAvailability = (selects) => {
    const variants = window.ProductVariantSettings().variants;
    const selection = selectedOptionValues(selects);
    selects.forEach((select) => {
      const options = select.options;
      for (let i = 0; i < options.length; i++) {
        const exists = window.optionCombinationExists(variants, selection, select.name, options[i].value);
        window.setIfDifferent(options[i], "disabled", !exists);
      }
    });
  };

  const resolveSelectedVariant = (selects, changed) => {
    const variants = window.ProductVariantSettings().variants;
    const exact = selectedOptionValues(selects);
    const match = variants.find((v) => window.variantMatchesSelection(v, exact));
    if (match) return match;

    const selection = {};
    selects.forEach((select) => (selection[select.name] = select === changed ? select.value : null));
    selects.forEach((select) => {
      if (select === changed) return;
      const options = select.options;
      for (let i = 0; i < options.length; i++) {
        if (window.optionCombinationExists(variants, selection, select.name, options[i].value)) {
          selection[select.name] = options[i].value;
          break;
        }
      }
    });
    return variants.find((v) => window.variantMatchesSelection(v, selection));
  };

  const initFindInStoreAddToCart = () => {
    const sidebar = document.querySelector(SEL.findInStore.sidebar);
    if (!sidebar) return;

    const findInStoreSelects = sidebar.querySelectorAll(SEL.findInStore.optionSelect);
    findInStoreSelects.forEach((select) => {
      select.addEventListener("change", () => {
        const match = resolveSelectedVariant(findInStoreSelects, select);
        if (match) window.ProductVariantState.setVariant(match);
      });
    });

    const chooseShownVariant = () => {
      const shown = findInStoreSelects.length > 0 && resolveSelectedVariant(findInStoreSelects);
      if (shown) window.ProductVariantState.setVariant(shown);
    };

    sidebar.querySelector(SEL.findInStore.addToCartButton).addEventListener("click", () => {
      chooseShownVariant();
      document.querySelector(SEL.findInStore.closeButton)?.click();
      document.querySelector(SEL.variantForm)?.requestSubmit();
    });

    sidebar.querySelector(SEL.findInStore.notifyMeButton)?.addEventListener("click", () => {
      chooseShownVariant();
      document.querySelector(SEL.findInStore.closeButton)?.click();
      document.querySelector(SEL.notifyMeButton)?.click();
    });
  };

  const initFindInStoreVariantSync = () => {
    const findInStoreSelects = document.querySelectorAll(SEL.findInStore.optionSelect);
    const findInStorePriceActual = document.querySelector(SEL.findInStore.priceActual);
    const findInStorePriceCompare = document.querySelector(SEL.findInStore.priceCompare);
    const findInStoreAddToCartButton = document.querySelector(SEL.findInStore.addToCartButton);
    const findInStoreNotifyMeButton = document.querySelector(SEL.findInStore.notifyMeButton);
    if (!findInStoreAddToCartButton) return;
    const sidebar = document.querySelector(SEL.findInStore.sidebar);

    updateSelectAvailability(findInStoreSelects);

    let chosenVariant = null;

    const selectVariantOptions = (v) => {
      findInStoreSelects.forEach((select) => {
        const value = v[select.name];
        if (value !== undefined && select.value !== value) select.value = value;
      });
    };

    const showVariant = (v) => {
      selectVariantOptions(v);
      updateSelectAvailability(findInStoreSelects);

      const price = window.formatVariantPrice(v);
      if (findInStorePriceActual) window.setIfDifferent(findInStorePriceActual, "innerHTML", price.actual);
      if (findInStorePriceCompare) window.showComparePrice(findInStorePriceCompare, price.compare);

      const settings = window.ProductVariantSettings();
      const { isUnavailable, buttonText } = window.getVariantPurchaseState(
        v,
        settings.variants,
        settings.variant_inventory_quantities,
        settings.variant_force_out_of_stock,
        settings.product_title,
        settings.inventory_reserve,
      );

      findInStoreAddToCartButton.style.display = isUnavailable ? "none" : "flex";
      if (!isUnavailable) {
        findInStoreAddToCartButton.disabled = false;
        window.setTextIfDifferent(findInStoreAddToCartButton, buttonText);
      }
      if (findInStoreNotifyMeButton) {
        findInStoreNotifyMeButton.style.display = isUnavailable ? "flex" : "none";
      }
      dropdownRefreshers.forEach((refresh) => refresh());
    };

    window.ProductVariantState.onVariantChange((v) => {
      if (!v) return;
      chosenVariant = v;
      if (sidebar.inert) selectVariantOptions(v);
      else showVariant(v);
    });

    document.querySelector(SEL.findInStore.openButton)?.addEventListener("click", () => {
      if (chosenVariant) showVariant(chosenVariant);
    });
  };

  const getDistanceKm = (lat1, lng1, lat2, lng2) => {
    const earthRadiusKm = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLng = ((lng2 - lng1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const isConfirmedInStock = (store) => {
    const badge = store.querySelector(".find-in-store__store-stock");
    return !!badge && !badge.hidden && store.classList.contains("find-in-store__store--in-stock");
  };

  const getStockRank = (store) => (isConfirmedInStock(store) ? 0 : 1);

  const sortStoreList = (storeList) => {
    Array.from(storeList.querySelectorAll(".find-in-store__store"))
      .map((store) => ({ store, rank: getStockRank(store), distance: Number(store.dataset.distance ?? Infinity) }))
      .sort((a, b) => a.rank - b.rank || a.distance - b.distance)
      .forEach(({ store }) => storeList.appendChild(store));
  };

  const updateStoreDistances = (storeList, lat, lng) => {
    storeList.hidden = false;
    const stores = Array.from(storeList.querySelectorAll(".find-in-store__store"));

    stores.forEach((store) => {
      const distance = getDistanceKm(lat, lng, Number(store.dataset.lat), Number(store.dataset.lng));
      store.dataset.distance = distance;
      const distanceEl = store.querySelector(".find-in-store__store-distance");
      distanceEl.textContent = `— ${distance.toFixed(1)} km`;
      distanceEl.hidden = false;
    });

    sortStoreList(storeList);
  };

  const expandNearestStore = (storeList) => {
    const visibleStores = storeList.querySelectorAll(".find-in-store__store:not([hidden])");
    storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
      const header = store.querySelector(".find-in-store__store-header");
      const details = document.getElementById(header.getAttribute("aria-controls"));
      const isNearest = store === visibleStores[0];
      header.setAttribute("aria-expanded", String(isNearest));
      if (details) details.hidden = !isNearest;
    });
  };

  const applyRadiusFilter = (storeList, radiusValue) => {
    if (radiusValue === "all") {
      storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
        store.hidden = false;
      });
      return;
    }

    const radiusKm = Number(radiusValue);
    storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
      const distance = store.dataset.distance;
      store.hidden = distance !== undefined && Number(distance) > radiusKm;
    });
  };

  const REQUEST_TIMEOUT_MS = 8000;
  const GEOCODE_REQUEST = { headers: { "User-Agent": "FindInStore/1.0" } };

  const GEOLOCATION_ERROR_MESSAGES = {
    1: "Location access denied — try entering your suburb or postcode instead.",
    2: "Couldn't determine your location — try entering your suburb or postcode instead.",
    3: "Location request timed out — please try again.",
  };

  const fetchWithTimeout = (url, init) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    return fetch(url, { ...init, signal: controller.signal }).finally(() => clearTimeout(timeoutId));
  };

  const reverseGeocodeLocation = async (lat, lng) => {
    const response = await fetchWithTimeout(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
      GEOCODE_REQUEST,
    );
    if (!response.ok) return null;
    const result = await response.json();
    return result?.display_name ?? null;
  };

  const geocodeLocation = async (query) => {
    const response = await fetchWithTimeout(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(`${query}, Australia`)}&format=json&limit=1`,
      GEOCODE_REQUEST,
    );
    if (!response.ok) return null;
    const [result] = await response.json();
    return result ? { lat: Number(result.lat), lng: Number(result.lon) } : null;
  };

  const STORES_SECTION = "find-in-store-stores";
  let storesLoaded = null;

  const weekdayIn = (timeZone) =>
    new Date().toLocaleDateString("en-US", { weekday: "long", timeZone: timeZone || undefined }).toLowerCase();

  const labelTodaysHours = (storeList) => {
    storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
      const today = weekdayIn(store.dataset.timezone);
      const hours = store.querySelector(".find-in-store__store-hours");
      if (!hours) return;
      const todayItem = hours.querySelector(`.find-in-store__store-hours-list-item[data-day="${today}"]`);
      const todayLabel = hours.querySelector(".find-in-store__store-hours-today");
      if (todayItem && todayLabel) {
        const todayHours = todayItem.children[1].textContent;
        todayLabel.textContent =
          todayHours.toLowerCase() === "closed" ? "Closed today" : `Open Today: ${todayHours}`;
      }
    });
  };

  const loadStores = (storeList) => {
    storesLoaded ??= fetch(`${window.location.pathname}?sections=${STORES_SECTION}`)
      .then((response) => {
        if (!response.ok) throw new Error(`store list answered ${response.status}`);
        return response.json();
      })
      .then((sections) => {
        const template = document.createElement("template");
        template.innerHTML = sections[STORES_SECTION];
        storeList.append(...template.content.querySelectorAll(".find-in-store__store"));
        labelTodaysHours(storeList);
      })
      .catch((error) => {
        storesLoaded = null;
        throw error;
      });
    return storesLoaded;
  };

  const initFindInStoreList = () => {
    const storeList = document.querySelector(".find-in-store__stores");
    if (!storeList) return;

    storeList.addEventListener("click", (event) => {
      const target = event.target;
      const header = target.closest(".find-in-store__store-header");
      if (header) {
        const isExpanded = header.getAttribute("aria-expanded") === "true";
        header.setAttribute("aria-expanded", String(!isExpanded));
        document.getElementById(header.getAttribute("aria-controls")).hidden = isExpanded;
        return;
      }
      const toggle = target.closest(".find-in-store__store-hours-toggle");
      if (toggle) {
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isExpanded));
        toggle.textContent = isExpanded ? "View opening hours" : "Hide opening hours";
        document.getElementById(toggle.getAttribute("aria-controls")).hidden = isExpanded;
      }
    });

    const radiusSelect = document.querySelector("#find-in-store-radius-select");
    const locationInput = document.querySelector("#find-in-store-location-input");
    const locationSearchIcon = document.querySelector(".find-in-store__location-search-icon");
    const useMyLocationButton = document.querySelector(".find-in-store__use-my-location-button");
    const useMyLocationButtonText = useMyLocationButton?.querySelector(
      ".find-in-store__use-my-location-button-text",
    );
    const statusEl = document.querySelector(".find-in-store__location-status");

    let searchToken = 0;

    const setStatus = (message, isError = false) => {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.hidden = !message;
      statusEl.classList.toggle("find-in-store__location-status--error", isError);
    };

    const searchControls = [locationInput, radiusSelect, useMyLocationButton, locationSearchIcon].filter(Boolean);
    const setControlsDisabled = (isDisabled) => {
      searchControls.forEach((el) => (el.disabled = isDisabled));
    };

    const searchIconMarkup = locationSearchIcon?.innerHTML;
    const setSearchLoading = (isLoading) => {
      setControlsDisabled(isLoading);
      if (!locationSearchIcon) return;
      locationSearchIcon.innerHTML = isLoading
        ? '<span class="loader--spinner" aria-hidden="true"></span>'
        : searchIconMarkup;
    };

    const setUseMyLocationLoading = (isLoading) => {
      setControlsDisabled(isLoading);
      if (useMyLocationButtonText) {
        useMyLocationButtonText.textContent = isLoading ? "Locating…" : "Use my location";
      }
    };

    const clearResults = () => {
      storeList.hidden = true;
      storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
        store.hidden = false;
        delete store.dataset.distance;
        const distanceEl = store.querySelector(".find-in-store__store-distance");
        distanceEl.hidden = true;
        distanceEl.textContent = "";
      });
    };

    const reportResultCount = () => {
      const visibleStores = storeList.querySelectorAll(".find-in-store__store:not([hidden])");
      if (visibleStores.length > 0) {
        setStatus("");
      } else if (radiusSelect.value === "all") {
        setStatus("No stores found.");
      } else if (radiusSelect.value === "50") {
        setStatus(`No stores found within 50 km — try "All stores" instead.`);
      } else {
        setStatus(`No stores found within ${radiusSelect.value} km — try a larger radius.`);
      }
    };

    const applyResults = async (lat, lng) => {
      try {
        await loadStores(storeList);
      } catch {
        setStatus("Couldn't load the store list — please try again.", true);
        return;
      }
      updateStoreDistances(storeList, lat, lng);
      applyRadiusFilter(storeList, radiusSelect.value);
      expandNearestStore(storeList);
      reportResultCount();
    };

    useMyLocationButton?.addEventListener("click", () => {
      if (!navigator.geolocation) {
        setStatus("Your browser doesn't support location access — try entering your suburb or postcode instead.", true);
        return;
      }

      const token = ++searchToken;
      setUseMyLocationLoading(true);
      clearResults();
      setStatus("Finding your location…");

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          if (token !== searchToken) return;
          const { latitude, longitude } = position.coords;
          await applyResults(latitude, longitude);
          setUseMyLocationLoading(false);

          try {
            const address = await reverseGeocodeLocation(latitude, longitude);
            if (token !== searchToken) return;
            if (address && locationInput) locationInput.value = address;
          } catch {}
        },
        (error) => {
          if (token !== searchToken) return;
          setUseMyLocationLoading(false);
          setStatus(
            GEOLOCATION_ERROR_MESSAGES[error.code] ??
              "Couldn't get your location — try entering your suburb or postcode instead.",
            true,
          );
        },
        { timeout: 10000, maximumAge: 0 },
      );
    });

    const searchLocation = async () => {
      const query = locationInput.value.trim();
      if (!query) {
        setStatus("Enter a suburb or postcode to search.", true);
        return;
      }

      const token = ++searchToken;
      setSearchLoading(true);
      clearResults();
      setStatus("Searching…");

      let coords;
      try {
        coords = await geocodeLocation(query);
      } catch (error) {
        if (token !== searchToken) return;
        setSearchLoading(false);
        setStatus(
          error.name === "AbortError"
            ? "Search timed out — please try again."
            : "Something went wrong — please try again.",
          true,
        );
        return;
      }
      if (token !== searchToken) return;
      setSearchLoading(false);

      if (!coords) {
        setStatus("Couldn't find that location — try a different suburb or postcode.", true);
        return;
      }

      await applyResults(coords.lat, coords.lng);
    };

    locationInput?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") searchLocation();
    });
    locationSearchIcon?.addEventListener("click", searchLocation);

    radiusSelect?.addEventListener("change", () => {
      applyRadiusFilter(storeList, radiusSelect.value);
      if (storeList.hidden) return;
      reportResultCount();
    });
  };

  const STOCK_URL = "/apps/util/api/v1/variant-inventory";
  const STOCK_MAX_AGE_MS = 120000;
  const IN_STOCK_LEVELS = ["in-stock", "low-stock"];

  const locationNumber = (id) => id.slice(id.lastIndexOf("/") + 1);

  const fetchStock = async (variantId) => {
    const response = await fetchWithTimeout(STOCK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ variant_id: variantId }),
    });
    if (!response.ok) throw new Error(`stock answered ${response.status}`);
    const { data } = await response.json();
    const levels = new Map();
    for (const { location_id, inventory_level } of data) levels.set(locationNumber(location_id), inventory_level);
    return levels;
  };

  const storeStockState = (store, levels) => {
    const locationId = store.dataset.locationId;
    if (!locationId) return "stockUnknown";
    const level = levels.get(locationId) ?? "out-of-stock";
    if (level === "out-of-stock") return "stockOut";
    return IN_STOCK_LEVELS.includes(level) ? "stockIn" : "stockUnknown";
  };

  const initFindInStoreStock = () => {
    const sidebar = document.querySelector(SEL.findInStore.sidebar);
    const storeList = document.querySelector(".find-in-store__stores");
    const stockError = document.querySelector(".find-in-store__stock-error");
    if (!sidebar || !storeList) return;

    const stockCache = new Map();
    let wantedVariantId = "";

    const stockEntry = (variantId) => {
      const cached = stockCache.get(variantId);
      if (cached && Date.now() - cached.at < STOCK_MAX_AGE_MS) return cached;
      const entry = { at: Date.now(), request: fetchStock(variantId) };
      entry.request.then(
        (levels) => (entry.levels = levels),
        () => stockCache.get(variantId) === entry && stockCache.delete(variantId),
      );
      stockCache.set(variantId, entry);
      return entry;
    };

    const renderStock = (levels) => {
      storeList.querySelectorAll(".find-in-store__store").forEach((store) => {
        const state = levels ? storeStockState(store, levels) : null;
        const badge = store.querySelector(".find-in-store__store-stock");
        badge.querySelector(".find-in-store__store-stock-text").textContent = state
          ? (storeList.dataset[state] ?? "")
          : "";
        badge.classList.toggle("find-in-store__store-stock--in-stock", state === "stockIn");
        badge.hidden = !state;
        store.classList.toggle("find-in-store__store--in-stock", state === "stockIn");
      });
    };

    const showStock = async () => {
      const variantId = document.querySelector(SEL.variantId)?.value ?? "";
      wantedVariantId = variantId;
      if (stockError) stockError.hidden = true;
      if (!variantId) return;

      const entry = stockEntry(variantId);
      try {
        await loadStores(storeList);
      } catch {
        return;
      }
      if (variantId !== wantedVariantId) return;
      if (!entry.levels) {
        renderStock(null);
        storeList.setAttribute("aria-busy", "true");
      }

      let levels = null;
      try {
        levels = await entry.request;
      } catch {}
      if (variantId !== wantedVariantId) return;

      storeList.removeAttribute("aria-busy");
      renderStock(levels);
      if (stockError) stockError.hidden = !!levels;
      sortStoreList(storeList);
      if (!storeList.hidden) expandNearestStore(storeList);
    };

    document.querySelector(SEL.findInStore.openButton)?.addEventListener("click", showStock);
    stockError?.querySelector(".find-in-store__stock-retry")?.addEventListener("click", showStock);
    sidebar.querySelectorAll(SEL.findInStore.optionSelect).forEach((select) => {
      select.addEventListener("change", showStock);
    });
  };

  const initFindInStoreCustomSelects = () => {
    document.querySelectorAll(".find-in-store__product-option-select-wrapper").forEach((wrapper) => {
      const select = wrapper.querySelector("select");
      if (!select) return;

      const button = document.createElement("button");
      button.type = "button";
      button.className = "find-in-store__dropdown-button";
      button.setAttribute("aria-haspopup", "listbox");
      button.setAttribute("aria-expanded", "false");

      const list = document.createElement("ul");
      list.className = "find-in-store__dropdown-list";
      list.setAttribute("role", "listbox");
      if (select.id) {
        list.id = `${select.id}-listbox`;
        button.setAttribute("aria-controls", list.id);
      }
      list.hidden = true;

      const close = () => {
        list.hidden = true;
        button.setAttribute("aria-expanded", "false");
        wrapper.classList.remove("find-in-store__product-option-select-wrapper--open");
      };

      const items = [...select.options].map((option, index) => {
        const item = document.createElement("li");
        item.className = "find-in-store__dropdown-option";
        item.setAttribute("role", "option");
        item.tabIndex = -1;
        item.textContent = (option.textContent || "").trim();
        item.addEventListener("click", () => {
          if (option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change"));
          close();
          button.focus();
        });
        list.append(item);
        return item;
      });

      const refresh = () => {
        const current = select.options[select.selectedIndex];
        window.setTextIfDifferent(button, current ? (current.textContent || "").trim() : "");
        items.forEach((item, index) => {
          window.setAttributeIfDifferent(item, "aria-selected", String(index === select.selectedIndex));
          window.setAttributeIfDifferent(item, "aria-disabled", String(select.options[index].disabled));
        });
      };

      const open = () => {
        refresh();
        list.hidden = false;
        button.setAttribute("aria-expanded", "true");
        wrapper.classList.add("find-in-store__product-option-select-wrapper--open");
        (items[select.selectedIndex] || items[0])?.focus();
      };

      button.addEventListener("click", () => (list.hidden ? open() : close()));

      wrapper.addEventListener("keydown", (event) => {
        if (list.hidden) return;
        if (event.key === "Escape") {
          event.preventDefault();
          close();
          button.focus();
          return;
        }
        const index = items.indexOf(document.activeElement);
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          event.preventDefault();
          const next = event.key === "ArrowDown" ? Math.min(index + 1, items.length - 1) : Math.max(index - 1, 0);
          items[next]?.focus();
        } else if ((event.key === "Enter" || event.key === " ") && index >= 0) {
          event.preventDefault();
          items[index].click();
        }
      });

      document.addEventListener("click", (event) => {
        if (!list.hidden && !wrapper.contains(event.target)) close();
      });

      select.addEventListener("change", refresh);
      select.tabIndex = -1;
      wrapper.classList.add("find-in-store__product-option-select-wrapper--enhanced");
      wrapper.append(button, list);
      refresh();
      dropdownRefreshers.push(refresh);
    });
  };

  initFindInStoreAddToCart();
  initFindInStoreVariantSync();
  initFindInStoreList();
  initFindInStoreStock();
  initFindInStoreCustomSelects();
})();
